// src/hooks/useUrlMetadata.ts
import { useCallback, useMemo, useRef, useState } from 'react';
import debounce from 'lodash.debounce';
import { fetchUrlMetadata, UrlMetadata } from 'util/fetchUrlMetadata';

export function useUrlMetadata() {
  const [meta, setMeta] = useState<UrlMetadata | null>(null);
  const [loading, setLoading] = useState(false);
  const latestRef = useRef<string>('');

  const run = useCallback(async (url: string) => {
    if (!url) return;
    latestRef.current = url;
    setLoading(true);
    try {
      const m = await fetchUrlMetadata(url);
      if (latestRef.current === url) setMeta(m);
    } finally {
      setLoading(false);
    }
  }, []);

  const debounced = useMemo(() => debounce(run, 360), [run]);
  return { meta, setMeta, loading, fetchNow: run, fetchDebounced: debounced };
}
